"use strict";
/** @module index */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Calls = exports.BlackList = exports.Users = exports.Contacts = exports.Chat = exports.Messages = exports.Dialogs = exports.startChat = exports.logout = exports.addErrorListener = void 0;
var blackList_1 = require("./blackList");
var logger_1 = __importStar(require("./logger"));
Object.defineProperty(exports, "addErrorListener", { enumerable: true, get: function () { return logger_1.addErrorListener; } });
var qbAdapter = __importStar(require("./QBAdapter"));
var init_1 = __importDefault(require("./init"));
var log = logger_1.default.module('main');
/** @ignore */
var model = init_1.default();
var _qbListenersInited = false;
/** @ignore */
var initQBListeners = function () {
    if (_qbListenersInited) {
        log.info('QBListeners already init');
        return;
    }
    _qbListenersInited = true;
    log.info('start services');
    qbAdapter.setLastUserActivityListener(model.Users.activityChange);
    qbAdapter.setSubscribeListener(qbAdapter.confirmSubscribe);
    qbAdapter.setMessagesListener(model.Messages.onMessage);
    qbAdapter.setOnReadStatusListener(model.Messages.onReadStatus);
    qbAdapter.setOnDeliveredStatusListener(model.Messages.onDeliveredStatus);
    qbAdapter.setMessagesErrorListener(model.Messages.onMessageError);
    qbAdapter.setSentMessageCallback(function (payload) {
        log.info('### onSentMessageCallback', { payload: payload });
    });
    qbAdapter.setContactListListener(model.Contacts.onContactChangeStatus);
    qbAdapter.setKickOccupantListener(model.Dialogs.onKickOccupant);
    qbAdapter.setOnDisconnectedListener();
    qbAdapter.setOnReconnectListener();
    qbAdapter.setOnMessageTypingListener();
    qbAdapter.setOnSystemMessagesListener(model.Messages.onDeleteMessage, model.Dialogs.onJoinGroup);
    /*
    Sometimes setOnCallListener throw an error: TypeError Attempted to assign to readonly property.
    https://slippery-snails.atlassian.net/browse/TSP-2318
  
    It appears only at iOS devices and for a small number of people
    */
    try {
        qbAdapter.webRTC.setOnCallListener(model.Calls.onWebRTCEvent);
        qbAdapter.webRTC.setOnUserNotAnswerListener(model.Calls.onWebRTCEvent);
        qbAdapter.webRTC.setOnAcceptCallListener(model.Calls.onWebRTCEvent);
        qbAdapter.webRTC.setOnRejectCallListener(model.Calls.onWebRTCEvent);
        qbAdapter.webRTC.setOnStopCallListener(model.Calls.onWebRTCEvent);
        qbAdapter.webRTC.setOnUpdateCallListener(model.Calls.onWebRTCEvent);
        qbAdapter.webRTC.setOnSessionCloseListener(model.Calls.onWebRTCEventSessionClose);
        qbAdapter.webRTC.setOnSessionConnectionStateChangedListener(model.Calls.onWebRTCEvent);
        qbAdapter.webRTC.setOnRemoteStreamListener(model.Calls.onWebRTCEvent);
    }
    catch (error) {
        log.error('Error WebRTC init handlers', { error: error });
    }
};
function buildQBConfig(config) {
    var qbConfig = {
        debug: { mode: config.qbDebug ? 1 : 0 },
        on: {
            sessionExpired: function (handleResponse, retry) {
                log.info('Session expired');
                if (typeof config.sessionExpiredHandler === 'function') {
                    log.info('Request new session');
                    config.sessionExpiredHandler().then(function (session) {
                        log.info('Set new session and retry');
                        model.Chat.setSession(session);
                        retry(session);
                    }, function (error) {
                        log.info('Error during received new session', { error: error });
                        handleResponse();
                    });
                    return;
                }
                handleResponse();
            },
        },
    };
    if (config.endpoints) {
        qbConfig.endpoints = config.endpoints;
    }
    // this allows to set websocket url
    if (config.chatProtocol) {
        qbConfig.chatProtocol = config.chatProtocol;
    }
    return qbConfig;
}
/**
 * To login to chat you need pass valid session and QuickBlox credentials. The session you can get from our node service (Red).
 *
 * You can use another method from this lib only after that method resolve.
 */
var startChat = function (creds, session, redEndpoint, config) {
    if (config === void 0) { config = { debug: false, qbDebug: false }; }
    return __awaiter(void 0, void 0, void 0, function () {
        var qbConfig;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (config.debug) {
                        log.info('enable debug chat');
                        logger_1.initLogger();
                    }
                    log.info('start chat');
                    qbConfig = buildQBConfig(config);
                    // TODO: Dirty hack for connect to WebRTC on PWA. WebRTC want init in first time
                    try {
                        qbAdapter.qbInit(creds, qbConfig);
                    }
                    catch (e) {
                        qbAdapter.qbInit(creds, qbConfig);
                    }
                    log.info('connect', { session: session });
                    return [4 /*yield*/, qbAdapter.connect({ userId: session.user_id, password: session.token })];
                case 1:
                    _a.sent();
                    initQBListeners();
                    return [4 /*yield*/, model.Chat.setSession(session)];
                case 2:
                    _a.sent();
                    if (redEndpoint) {
                        log.info('Set endpoint', { redEndpoint: redEndpoint });
                        model.Chat.setRedEndpoint(redEndpoint);
                    }
                    blackList_1.initBlackList();
                    return [2 /*return*/];
            }
        });
    });
};
exports.startChat = startChat;
// todo: removed autosend location, redo to push location from PWA
// async function sendGeo({url, session}: {url: string, session: Session}) {
//   try {
//     const location = await getCurrentGeoPosition();
//
//     fetch(`${url}/location`, {
//       body: JSON.stringify({ session, location }),
//       headers: {
//         "Content-Type": "application/json"
//       },
//       method: "PUT"
//     });
//   } catch (e) {}
// }
function logout() {
    _qbListenersInited = false;
    model.Chat.api.logout();
}
exports.logout = logout;
exports.Dialogs = model.Dialogs.api;
exports.Messages = model.Messages.api;
exports.Chat = __assign(__assign({}, model.Chat.api), { logout: logout });
exports.Contacts = model.Contacts.api;
exports.Users = model.Users.api;
exports.BlackList = model.BlackList.api;
exports.Calls = model.Calls.api;
//# sourceMappingURL=index.js.map